/* eslint-disable no-console */

const langId = $('#langId').val();
const storeId = $('#storeId').val();

window.openAfterpay = function (withKlarna) {
  if (withKlarna) {
    window.triggerVueMethod('showKlarnaAfterpayModal');
  } else {
    window.triggerVueMethod('showAfterpayModal');
  }
};

$('body').on('click', '#wcs-afterpay-overlay .wcs-close-btn', function (e) {
  e.preventDefault();
  $('body').removeClass('rb-overlay-open');
  $('#wcs-afterpay-overlay').removeClass('active');
});

function addToCartCall(url, params, callback) {
  const ocIdVal = $('#ocIdVal').val();
  const ocCountryVal = $('#ocCountryVal').val();
  $.ajax({
    url: url,
    headers: {
      'Ocp-Apim-Subscription-Key': '',
      'OC-Id': ocIdVal,
      'OC-Country': ocCountryVal,
    },
    type: "POST",
    data: JSON.stringify(params),
    dataType: "json",
    contentType: "application/json",
    success: function (data, status, xhr) {
      console.log('OC call success: ' + xhr.status);
      sessionStorage.removeItem("rayban." + storeId + "." + langId + ".sidebar_refreshLS");
      sessionStorage.removeItem("rayban." + storeId + "." + langId + ".headerprofile_refreshLS");
      window.location.href = $('#shopBagURL').val();
      callback(xhr.status);
    },
    error: function (xhr, status, error) {
      console.log('OC call failed: ' + xhr + ', stauts: ' + status + ', error: ' + error);
      callback(xhr.status);
    },
  });
}

function addToWishCall(url, params, callback) {
  const ocIdVal = $('#ocIdVal').val();
  const ocCountryVal = $('#ocCountryVal').val();
  $.ajax({
    url: url,
    headers: {
      'OC-Id': ocIdVal,
      'OC-Country': ocCountryVal,
    },
    type: "POST",
    data: JSON.stringify(params),
    dataType: "json",
    contentType: "application/json",
    success: function (data, status, xhr) {
      callback(xhr.status);
    },
    error: function (xhr, status, error) {
      console.log('OC call failed: ' + xhr + ', stauts: ' + status + ', error: ' + error);
      callback(xhr.status);
    },
  });
}

window.fluidAddToCart = function (recipe, callback) {
  const storeID = $('#storeId').val();
  if (recipe.custom.bom.upc === null) {
    recipe.custom.bom.upc = "";
  }
  const params = recipe.custom.bom;
  const hostname = window.location.hostname;
  const url = "https://" + hostname + "/wcs/resources/store/remix/add-to-cart";
  $.ajax({
    url: "https://" + hostname + "/webapp/wcs/stores/servlet/CreateGuestUser?storeId=" + storeID,
    type: "POST",
    dataType: "json",
    success: function (dati, status, xhr) {
      const userId = dati.userId;
      const et = '&';
      let userGuestId;
      if (userId.indexOf('G') != -1) {
        userGuestId = userId.split('-')[1];
      } else {
        userGuestId = userId;
      }
      const ShopBagUrl = $('input[name=shopBagURL]').val().split('&')[0] + et + "userId=" + userGuestId + et + $('input[name=shopBagURL]').val().split('&')[2] + et + $('input[name=shopBagURL]').val().split('&')[3];
      $('input[name=shopBagURL]').attr('value', ShopBagUrl);
      console.log('OC - CreateGuestUser call success: ' + xhr.status);
      addToCartCall(url, params, callback);
    },
    error: function (xhr, status, error) {
      window.console.log('/add-to-cart Error');
      console.log('OC - CreateGuestUser call failed: ' + xhr.status + ', stauts: ' + status + ', error: ' + error);
    },
  });
};

function deleteCookie(name) {
  document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/';
}

window.fluidAddToWishes = function (recipe, callback) {
  const params = recipe.custom.bom;
  const hostname = window.location.hostname;
  const url = "https://" + hostname + "/wcs/resources/store/remix/add-to-wishes";
  deleteCookie('miniWhislistSaved');
  addToWishCall(url, params, callback);
};



// WEBPACK FOOTER //
// ./desktop/one-configurator/desktopFluidRB.js